import { render, staticRenderFns } from "./ChangeStockAmountModal.vue?vue&type=template&id=24a919e0"
import script from "./ChangeStockAmountModal.vue?vue&type=script&lang=js"
export * from "./ChangeStockAmountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports